// extracted by mini-css-extract-plugin
module.exports = {"container":"Place_container__PpAWu","wrapper":"Place_wrapper__zpSvY","text":"Place_text__Wblgb"};